/** @jsxImportSource @emotion/react */
import { Tooltip } from "components/general/Tooltip";
import React, { useCallback, useMemo } from "react";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Amount } from "../../types/amount";
import { FlexBetweenContainer } from "../../containers/FlexBetweenContainer";
import { FlexColumnBetween } from "../general/FlexColumnBetween/FlexColumnBetween";
import { FlexContainer } from "../../containers/FlexContainer";
import { DetailsRightColumnText } from "./elements/DetailsRightColumnText";
import { DetailsLeftColumnText } from "./elements/DetailsLeftColumnText";
import { useTokenListByChain } from "../../hooks/useTokenListByChain";
import { isManyToOne, isOneToMany, isOneToOne } from "utils/quoteUtils";
import { getTokenTicker } from "../../utils/tokenUtils";

const willBeConvertedText = "Amount that will be converted, after the network cost is deducted.";
export const TotalReceivingRow: React.FC = () => {
  const quote = GlobalStore.useState(s => s.quote);
  const theme = GlobalStore.useState(s => s.theme);
  const makerTokens = GlobalStore.useState(s => s.makerTokens);
  const tokenList = useTokenListByChain();
  const getAmount = useCallback((): Amount => {
    return quote?.makerTokens ? Object.values(quote?.makerTokens)[0]?.amount : Amount.ZERO;
  }, [quote?.makerTokens]);
  const totalUsd = useMemo(() => {
    const tokens = quote?.makerTokens ? Object.values(quote?.makerTokens) : [];
    return tokens
      .reduce((total, token) => {
        return total.add(token.amountUsd);
      }, Amount.ZERO)
      .value.toNumber()
      .toFixed(2);
  }, [quote?.makerTokens]);
  if (quote == null) {
    return null;
  }

  return (
    <FlexBetweenContainer
      data-testid="will-be-converted-row"
      widthExpand={true}
      justifyContent={"space-between"}
    >
      <FlexContainer style={{ color: theme.font.secondary.default }}>
        <Tooltip title={willBeConvertedText}>
          <DetailsLeftColumnText>Total receiving</DetailsLeftColumnText>
        </Tooltip>
      </FlexContainer>
      <FlexColumnBetween>
        <DetailsRightColumnText>
          {(isOneToOne(quote) || isManyToOne(quote)) && (
            <>
              {getAmount().toDisplay(makerTokens[0].tokenAddress, tokenList)}{" "}
              {getTokenTicker(makerTokens[0].tokenAddress, tokenList)} ($
              {totalUsd})
            </>
          )}
          {isOneToMany(quote) && <>${totalUsd}</>}
        </DetailsRightColumnText>
      </FlexColumnBetween>
    </FlexBetweenContainer>
  );
};
